import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a479184fab3d0014a53351/cartelix/src/app/homepage/HomepageInteractive.tsx");
